<div
  class="scope-overview-header"
  *ngIf="scope">
  <!-- title -->
  <div class="scope-overview-header-title">
    <div class="scope-name">
      <i
        class="material-symbols-rounded"
        *ngIf="scope.identity?.isTemplate">
        copy_all
      </i>
      <i
        class="material-symbols-rounded"
        *ngIf="!scope.identity?.isTemplate && !scope.isScopeByRole() && !scope.isScopeByScenario()">
        equalizer
      </i>
      <i
        class="material-symbols-rounded"
        *ngIf="!scope.identity?.isTemplate && scope.isScopeByRole()">
        table_chart
      </i>
      <i
        class="material-symbols-rounded"
        *ngIf="!scope.identity?.isTemplate && scope.isScopeByScenario()">
        alt_route
      </i>
      <h3
        class="product-heading-bold primary-blue-violet-p pt-1.5"
        *ngIf="!editName">
        {{ scope.name }}
      </h3>
      <mat-icon
        (click)="editName = true; $event.stopPropagation()"
        *ngIf="!editName && approvalFlowService.isScopeEditable(scope)"
        class="material-symbols-rounded fill orange text-base ml-1.5 pointer">
        mode_edit
      </mat-icon>
      <scope-ui-input
        *ngIf="editName"
        class="edit-name"
        (click)="$event.stopPropagation()"
        [initialValue]="scope.name"
        [autofocus]="true"
        (onInputBlurChange)="updateScopeName($event, scope)" />
    </div>
  </div>

  <!-- Scope Status / Change Request Status -->
  <div class="font-newJuneBold">
    <div
      class="text-xl mb-2"
      [ngClass]="getCellClass(scope.status)">
      {{ changeRequest && hasChangeRequestsFeature ? 'Change request' : scope.getStatusText() }}
    </div>
    <div class="text-xs">
      <span class="neutral-black">Created by:</span>
      {{
        changeRequest && hasChangeRequestsFeature
          ? changeRequest.auditMetadata?.createdBy?.fullName
          : scope.createdBy?.getFullname()
      }}
    </div>
  </div>

  <div class="scope-number-date font-newJuneBold">
    <div class="text-xl flex items-center gap-1">
      <span
        class="primary-blue-violet cursor-pointer sow-link"
        (click)="redirectToSow(scope.scopeOfWorkVersion.identity?.id)"
        *ngIf="scope.scopeOfWorkVersion">
        F-{{ scope.scopeOfWorkVersion.identity?.localId }}
      </span>
      <span
        *ngIf="scope.scopeOfWorkVersion"
        class="material-symbols-rounded primary-blue-violet-p cursor-default">
        arrow_forward
      </span>
      <span class="primary-blue-violet-p">S-{{ scope.identity?.localId }}</span>

      <ng-container
        *ngIf="changeRequest"
        [has-setting]="ApplicationSetting.CHANGE_REQUEST && ApplicationSetting.SCOPE__ENABLE_CHANGE_REQUEST">
        <span class="material-symbols-rounded orange cursor-default"> arrow_forward </span>
        <span>{{ changeRequest?.getChangeRequestId() }}</span>
      </ng-container>
    </div>
    <div class="text-xs">
      <span class="neutral-black">Date created:</span>
      {{
        (changeRequest && hasChangeRequestsFeature ? changeRequest.auditMetadata?.createdOn : scope.createdTs)
          | dateFormat: 'shortDate'
      }}
    </div>
  </div>
</div>
